import { cx } from '../../utils/cx';

import NavItem from './NavItem';

import type { NavItemType, NavItemDividerType } from './config';

const getPathname = (href?: string) => href?.split('?')[0] ?? '';

interface INavListProps {
  /** URL of the currently active item (pathname). */
  activeUrl?: string;
  /** Additional CSS classes to apply to the list. */
  className?: string;
  /** List of items to display. */
  items: (NavItemType | NavItemDividerType)[];
}

const NavList = ({ activeUrl, items, className }: INavListProps) => {
  const activeItem = items.find(
    (item) =>
      getPathname(item.href) === activeUrl || item.items?.some((subItem) => getPathname(subItem.href) === activeUrl)
  );

  return (
    <ul className={cx('mt-4 flex flex-col px-2 lg:px-4', className)}>
      {items.map((item, index) => {
        if (item.divider) {
          return (
            <li key={index} className="w-full px-0.5 py-2">
              <hr className="bg-border-secondary h-px w-full border-none" />
            </li>
          );
        }

        if (item.items?.length) {
          return (
            <details
              key={item.label}
              open={getPathname(activeItem?.href) === getPathname(item.href)}
              className="appearance-none py-0.5"
            >
              <NavItem href={item.href} icon={item.icon} type="collapsible">
                {item.label}
              </NavItem>

              <dd>
                <ul className="py-0.5">
                  {item.items.map((childItem) => (
                    <li key={childItem.label} className="py-0.5">
                      <NavItem
                        href={childItem.href}
                        type="collapsible-child"
                        current={activeUrl === getPathname(childItem.href)}
                      >
                        {childItem.label}
                      </NavItem>
                    </li>
                  ))}
                </ul>
              </dd>
            </details>
          );
        }

        return (
          <li key={item.label} className="py-0.5">
            <NavItem type="link" icon={item.icon} href={item.href} current={activeUrl === getPathname(item.href)}>
              {item.label}
            </NavItem>
          </li>
        );
      })}
    </ul>
  );
};

export default NavList;
